module.exports = __webpack_public_path__ + "img/Digital-Spin.1e11bd66.png";